export const urlMapping = {
    home: {
        logo: "img/avatar/avatar_padre.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.home"],
    },
    ricercaFocolai: {
        logo: "img/documenti/documento.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.ricerca_focolai"],
        fatherLabel: "PageTitles.sor_malattie"
    },
    ricercaSegnalazioni: {
        logo: "img/documenti/documento.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.ricerca_segnalazioni"],
        fatherLabel: "PageTitles.sor_malattie"
    },
    ricercaContactTracing: {
        logo: "img/documenti/documento.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.ricerca_contactTracing"],
        fatherLabel: "PageTitles.sor_malattie"
    },
    associaSegnalazioni: {
        path: "associaSegnalazioni",
        logo: "img/documenti/documento.png",
        logoAlt: "",
        requiredRoles: [],
        form: "filtroSegnalazioni",
        label: ["PageTitles.associa_segnalazioni"],
        fatherLabel: "PageTitles.sor_malattie"
    },
    InformazioniFocolaio: {
        path: "InformazioniFocolaio",
        logo: "img/documenti/documento.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.ins_focolaio", "PageTitles.modifica_focolaio"],
        fatherLabel: "PageTitles.sor_malattie"
    },
    inserimentoSegnalazioni: {
        path: "inserimentoSegnalazioni",
        logo: "img/documenti/documento.png",
        logoAlt: "",
        form: "filtroSegnalazioni",
        requiredRoles: [],
        label: ["PageTitles.ins_segnalazione"],
        fatherLabel: "PageTitles.monitoraggio"
    },
    wizardSegnalazione: {
        logo: "img/documenti/documento.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.ins_segnalazione"],
        fatherLabel: "PageTitles.sor_malattie",
    },
    convertiSegnalazione: {
        logo: "img/documenti/documento.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.loading_converti_segnalazione"],
        fatherLabel: "PageTitles.sor_malattie",
    },
    manuali: {
        logo: "img/documenti/documento.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.manuali"],
        fatherLabel: "PageTitles.sor_malattie",
    },
    invioSchedeSpeciali: {
        path: "invioSchedeSpeciali",
        logo: "img/documenti/documento.png",
        logoAlt: "",
        form: "filtroSegnalazioni",
        requiredRoles: [],
        label: ["PageTitles.inv_schedeSpeciali"],
        fatherLabel: "PageTitles.sor_malattie",
    },
        integrazioniLIS: {
        path: "integrazioniLIS",
        logo: "img/documenti/documento.png",
        logoAlt: "",
        form: "filtroSegnalazioni",
        requiredRoles: [],
        label: ["PageTitles.integrazioni_LIS"],
        fatherLabel: "PageTitles.sor_malattie",
    },
        segnalazioniDaLIS: {
        path: "segnalazioniDaLIS",
        logo: "img/documenti/documento.png",
        logoAlt: "",
        form: "filtroSegnalazioni",
        requiredRoles: [],
        label: ["PageTitles.segnalazioni_da_LIS"],
        fatherLabel: "PageTitles.sor_malattie",
    },
    esitoTBC: {
        path: "esitoTBC",
        logo: "img/documenti/documento.png",
        logoAlt: "",
        form: "filtroSegnalazioni",
        requiredRoles: [],
        label: ["PageTitles.monitoraggio_tbc"],
        fatherLabel: "PageTitles.sor_malattie",
    },
    statoInvioPremal: {
        path: "statoInvioPremal",
        logo: "img/documenti/documento.png",
        logoAlt: "",
        form: "filtroSegnalazioni",
        requiredRoles: [],
        label: ["PageTitles.inv_premal"],
        fatherLabel: "PageTitles.sor_malattie",
    },
    exportSegnalazioni: {
        path: "exportSegnalazioni",
        logo: "img/documenti/documento.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.export_segnalazioni"],
        fatherLabel: "PageTitles.export_segnalazioni",
    },
    exportArbovirosi: {
        path: "exportArbovirosi",
        logo: "img/documenti/documento.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.export_arbovirosi"],
        fatherLabel: "PageTitles.export_arbovirosi",
    },
    reportStatistici: {
        path: "reportStatistici",
        logo: "img/documenti/documento.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.report_statistici"],
        fatherLabel: "PageTitles.report_statistici",
    },
    reportEpatite: {
        path: "reportEpatite",
        logo: "img/documenti/documento.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.report_epatite"],
        fatherLabel: "PageTitles.report_epatite",
    },
    homeHIV: {
        path: "homeHIV",
        logo: "img/avatar/avatar_padre.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.home_hiv"]
    },
    ricercaSegnalazioniHIV: {
        path: "ricercaSegnalazioniHIV",
        logo: "img/documenti/documento.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.ricerca_segnalazioni_hiv"],
        fatherLabel: "PageTitles.sorveglianza_hiv",
    },
    formHIV: {
        path: "formHIV",
        logo: "img/documenti/documento.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.inserisci_segnalazione_hiv"],
        fatherLabel: "PageTitles.sorveglianza_hiv",
    },
    gestioneDuplicatiHIV: {
        path: "gestioneDuplicatiHIV",
        logo: "img/documenti/documento.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.gestione_duplicati_hiv"],
        fatherLabel: "PageTitles.utilita_hiv",
    },
    loginSelect: {
        logo: "img/avatar/avatar_padre.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.login_select"]
    },
    notauthorized: {
        logo: "",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.notauthorized"]
    },
    default: {
        logo: "img/avatar/avatar_padre.png",
        logoAlt: "",
        requiredRoles: [],
        label: ["PageTitles.default"],
        fatherLabel: ""//TODO PROVA
    }
}
